import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PlanoContaMatrizListarComponent } from './plano-contas-matriz-listar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: PlanoContaMatrizListarComponent }
    ])],
    exports: [RouterModule]
})
export class PlanoContaMatrizListarRoutingModule { }
